webpackJsonp([1],{

/***/ "2Tf6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7xso":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var lib = __webpack_require__("j1ja");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36282df2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('footer',{attrs:{"id":"footer"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row d-flex justify-content-center text-center text-md-left"},[_c('div',{staticClass:"col-sm-12 col-md-auto d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"footer-logo mr-0 mr-md-5 mb-4 mb-md-0"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:('/static/img/alfa-logo.png'),expression:"'/static/img/alfa-logo.png'"}],attrs:{"alt":"Alfa"}}),_vm._v(" "),_c('div',{staticClass:"claim"},[_vm._v("Qualität für's Handwerk")])])]),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-3"},[_c('div',{staticClass:"footer-heading"},[_c('span',[_c('router-link',{attrs:{"to":{ name: 'Datenschutz' }}},[_vm._v("Datenschutz")])],1)])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6 col-md-3 mb-4 mb-sm-0"},[_c('div',{staticClass:"footer-heading"},[_c('span',[_vm._v("Impressum")])]),_vm._v(" "),_c('div',[_vm._v("Alfa GmbH")]),_vm._v(" "),_c('div',[_vm._v("Ferdinand-Porsche-Str. 10")]),_vm._v(" "),_c('div',[_vm._v("73479 Ellwangen")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6 col-md-3"},[_c('div',{staticClass:"footer-heading"},[_c('span',[_vm._v("Kontakt")])]),_vm._v(" "),_c('div',[_vm._v("kontakt@alfa-direkt.de")]),_vm._v(" "),_c('div',[_vm._v("07961 / 5799 - 0")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("fwqL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Home.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Home = ({
  data: function data() {
    return {
      keyword: '',
      videoIsVisible: false,
      clickedVideo: false,
      isB2B: false,
      flachdachSet: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['visitCount', 'playedVideo']), {
    content: function content() {
      return this.$store.getters.getContent('flachdach', this.keyword);
    }
  }),
  methods: {
    toggleVideo: function toggleVideo() {
      this.videoIsVisible = !this.videoIsVisible;
    }
  },
  mounted: function mounted() {
    this.keyword = this.$route.query.keyword;
    this.$store.dispatch('viewPage');
    this.$store.dispatch('setKeyword', this.keyword);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d1b926e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:('/static/img/teaser-bg.png'),expression:"'/static/img/teaser-bg.png'",arg:"background-image"}],staticClass:"hero bg-dark"},[_c('div',{staticClass:"hero-inner"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"hero-body"},[_c('h1',{staticClass:"text-center",domProps:{"innerHTML":_vm._s(_vm.content.h1Text)}}),_vm._v(" "),_c('p',{staticClass:"lead text-center mb-5",domProps:{"innerHTML":_vm._s(_vm.content.leadText)}}),_vm._v(" "),_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-xs-12 col-md d-flex justify-content-center align-items-center flex-column mb-5 mb-lg-0"},[(_vm.clickedVideo == false)?_c('a',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:('/static/img/video-thumbnail.png'),expression:"'/static/img/video-thumbnail.png'",arg:"background-image"}],staticClass:"video-thumbnail w-0",attrs:{"href":"javascript:"},on:{"click":function($event){_vm.clickedVideo = true; _vm.$store.dispatch('playVideo')}}}):_vm._e(),_vm._v(" "),(_vm.clickedVideo)?_c('iframe',{staticClass:"video",attrs:{"type":"text/html","width":"500","height":"305","src":"https://www.youtube.com/embed/yqGJQcNeoho?autoplay=1&rel=0&showinfo=0","allow":"encrypted-media","frameborder":"0","allowfullscreen":""}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col d-flex justify-content-center"},[_c('div',{staticClass:"d-block"},[_c('div',{staticClass:"buybox"},[_c('h2',{staticClass:"headline mb-4"},[_vm._v("Verbrauch berechnen")]),_vm._v(" "),_c('alfa-calculator')],1)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"bg-dark"},[_c('div',{staticClass:"container py-5"},[_c('div',{staticClass:"row d-flex align-items-center text-center text-sm-left"},[_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4 mb-4 mb-sm-0"},[_c('blockquote',{staticClass:"blockquote"},[_c('div',{staticClass:"mb-2"},[_c('div',{staticStyle:{"height":"27px"}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:('/static/img/5stars.png'),expression:"'/static/img/5stars.png'"}],attrs:{"alt":"5 Sterne"}})])]),_vm._v(" "),_c('p',{staticClass:"mb-1"},[_vm._v("Bin vollauf begeistert von Alfa EASY Flachdachabdichtung! Sehr gute und schnelle Verarbeitung! Und schnell belastbar! Danke!")]),_vm._v(" "),_c('footer',{staticClass:"blockquote-footer"},[_vm._v("Meinung von Uwe M.")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4 mb-5 mb-sm-0"},[_c('blockquote',{staticClass:"blockquote"},[_c('div',{staticClass:"mb-2"},[_c('div',{staticStyle:{"height":"27px"}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:('/static/img/5stars.png'),expression:"'/static/img/5stars.png'"}],attrs:{"alt":"5 Sterne"}})])]),_vm._v(" "),_c('p',{staticClass:"mb-1"},[_vm._v("Leicht zu verarbeiten, gute Haftung und qualitativ hochwertig. Zudem praktische Verpackung und gutes Preis-Leistungsverhältnis!")]),_vm._v(" "),_c('footer',{staticClass:"blockquote-footer"},[_vm._v("Meinung von Andreas")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 mt-sm-5 mt-md-0 text-center text-md-left"},[_c('div',{staticClass:"mb-3"},[_c('div',{staticStyle:{"height":"139px"}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:('/static/img/heimwerker-praxis.png'),expression:"'/static/img/heimwerker-praxis.png'"}],staticStyle:{"border":"solid 2px #fff","border-radius":"3px"},attrs:{"alt":""}})])]),_vm._v(" "),_vm._m(0,false,false)])])])]),_vm._v(" "),_c('div',{staticClass:"mb-5 bg-secondary"},[_c('div',{staticClass:"container py-5"},[_c('div',{staticClass:"row d-flex align-items-center"},[_c('div',{staticClass:"col-xs-12 col-lg-3 mb-4 mb-lg-0 text-center"},[_c('div',{staticStyle:{"height":"156.25px"}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:('/static/img/product.png'),expression:"'/static/img/product.png'"}],staticClass:"img-fluid",staticStyle:{"max-width":"250px"},attrs:{"alt":"Alfa EASY Flachdachabdichtung 1K"}})])]),_vm._v(" "),_vm._m(1,false,false)])])]),_vm._v(" "),_c('div',{staticClass:"container tutorial"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h2',{staticClass:"mb-3 mb-sm-5"},[_vm._v("Schnell und einfach "+_vm._s(_vm.content.objectText)+" abdichten")])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3 mb-sm-4"},[_c('div',{staticClass:"col-sm-4 order-2 order-sm-1"},[_c('div',{staticClass:"lazy-container"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:('/static/img/flachdach-untergrund-vorbereiten.jpg'),expression:"'/static/img/flachdach-untergrund-vorbereiten.jpg'"}],staticClass:"img-fluid rounded",attrs:{"alt":"Flachdach mit dem Besen abkehren"}})])]),_vm._v(" "),_vm._m(2,false,false)]),_vm._v(" "),_c('div',{staticClass:"row mb-4 mb-sm-5"},[_c('div',{staticClass:"col-sm-4 mb-3 mb-sm-0"},[_c('div',{staticClass:"lazy-container"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:('/static/img/flachdach-abkleben-gewebeband.jpg'),expression:"'/static/img/flachdach-abkleben-gewebeband.jpg'"}],staticClass:"img-fluid rounded",attrs:{"alt":"Flachdach mit Gewebeband abkleben"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 mb-3 mb-sm-0"},[_c('div',{staticClass:"lazy-container"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:('/static/img/flachdach-abkleben-gewebeband-ecken.jpg'),expression:"'/static/img/flachdach-abkleben-gewebeband-ecken.jpg'"}],staticClass:"img-fluid rounded",attrs:{"alt":"Auch die Ecken müssen abgeklebt werden"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 mb-3 mb-sm-0"},[_c('div',{staticClass:"lazy-container"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:('/static/img/flachdachabdichtung-kurz-umruehren.jpg'),expression:"'/static/img/flachdachabdichtung-kurz-umruehren.jpg'"}],staticClass:"img-fluid rounded",attrs:{"alt":"Den Inhalt des Beutels kurz umrühren"}})])])]),_vm._v(" "),_c('div',{staticClass:"row mb-4"},[_vm._m(3,false,false),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:('/static/img/material-verteilen-randbereiche.jpg'),expression:"'/static/img/material-verteilen-randbereiche.jpg'"}],staticClass:"img-fluid rounded",attrs:{"alt":"Das Material an den Randbereichen auftragen"}})])]),_vm._v(" "),_c('div',{staticClass:"row mb-3 mb-sm-5"},[_c('div',{staticClass:"col-sm-4 order-3 order-sm-1 mb-3 mb-sm-0"},[_c('div',{staticClass:"lazy-container"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:('/static/img/flachdachabdichtung-verteilen.jpg'),expression:"'/static/img/flachdachabdichtung-verteilen.jpg'"}],staticClass:"img-fluid rounded",attrs:{"alt":"Flachdachabdichtung verteilen"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 order-2 order-sm-2 mb-3 mb-sm-0"},[_c('div',{staticClass:"lazy-container"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:('/static/img/flachdachabdichtung-verteilen-erste-schicht.jpg'),expression:"'/static/img/flachdachabdichtung-verteilen-erste-schicht.jpg'"}],staticClass:"img-fluid rounded",attrs:{"alt":"Flachdachabdichtung verteilen"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 order-1 order-sm-3 mb-3 mb-sm-0"},[_c('div',{staticClass:"lazy-container"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:('/static/img/material-verteilen-walze.jpg'),expression:"'/static/img/material-verteilen-walze.jpg'"}],staticClass:"img-fluid rounded",attrs:{"alt":"Eine Walze verwenden"}})])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3 mb-sm-4"},[_c('div',{staticClass:"col-sm-4 order-2 order-sm-1"},[_c('div',{staticClass:"lazy-container"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:('/static/img/flachdachabdichtung-zweite-schicht-rand.jpg'),expression:"'/static/img/flachdachabdichtung-zweite-schicht-rand.jpg'"}],staticClass:"img-fluid rounded",attrs:{"alt":"Zweite Schicht der Flachdachabdichtung am Randbereich verteilen"}})])]),_vm._v(" "),_vm._m(4,false,false)]),_vm._v(" "),_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-sm-4 mb-3 mb-sm-0"},[_c('div',{staticClass:"lazy-container"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:('/static/img/flachdachabdichtung-zweite-schicht.jpg'),expression:"'/static/img/flachdachabdichtung-zweite-schicht.jpg'"}],staticClass:"img-fluid rounded",attrs:{"alt":"Zweite Schicht auftragen"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 mb-3 mb-sm-0"},[_c('div',{staticClass:"lazy-container"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:('/static/img/material-zweite-schicht.jpg'),expression:"'/static/img/material-zweite-schicht.jpg'"}],staticClass:"img-fluid rounded",attrs:{"alt":"Zweite Schicht auftragen"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 mb-3 mb-sm-0"},[_c('div',{staticClass:"lazy-container"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:('/static/img/flachdach-abgedichtet.jpg'),expression:"'/static/img/flachdach-abgedichtet.jpg'"}],staticClass:"img-fluid rounded",attrs:{"alt":"Abgedichtetes Flachdach"}})])])])]),_vm._v(" "),_c('div',{staticClass:"bg-dark py-5"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-lg-5 m-auto"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body",staticStyle:{"padding":"35px"}},[_c('h3',{staticClass:"font-weight-bold mb-4"},[_vm._v("Verbrauch berechnen")]),_vm._v(" "),_c('alfa-calculator')],1)])])])])])])}
var Home_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"m-0 text-white"},[_vm._v("Beim Praxistest von \"Heimwerker Praxis\" erreichte unsere EASY Flachdachabdichtung die Spitzen-Note von 1,5.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ml-lg-2 col"},[_c('div',{staticClass:"benefits row"},[_c('div',{staticClass:"col-xs-12 col-lg-6"},[_c('div',{staticClass:"benefit"},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Einfache Verarbeitung in 2 Anstrichen\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-lg-6"},[_c('div',{staticClass:"benefit"},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Kurze Aushärtungszeit, sofort wasserdicht\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-lg-6"},[_c('div',{staticClass:"benefit"},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" 5 Jahre Gewährleistung\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-lg-6"},[_c('div',{staticClass:"benefit"},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Rissüberbrückend bis 3 mm\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-lg-6"},[_c('div',{staticClass:"benefit"},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" UV- und wetterbeständig, überstreichbar\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-lg-6"},[_c('div',{staticClass:"benefit"},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Gebrauchsfertig und lösemittelfrei\n              ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col d-flex justify-content-center flex-column order-1 order-sm-2 mb-3 mb-sm-0"},[_c('h3',[_vm._v("Untergrund vorbereiten")]),_vm._v(" "),_c('p',[_vm._v("Um eine optimale Haftung zu erzielen, muss der Untergrund fest, tragfähig und frei von Verunreinigungen sein. Die zu beschichtende Fläche darf keine Reste von Öl, Fett, Staub und anderen Trennschichten aufweisen. Lose liegende Teile wie Steine und Reste von Altbelägen sind komplett zu entfernen.")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("Fugen sind mit Flachdachreparatur 1K zu befüllen. Die Ränder und Überlappungen werden mit UV-Gewebeband abgeklebt, um einen sauberen Übergang der Randbereiche zu gewährleisten.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col"},[_c('h3',[_vm._v("Erste Schicht auftragen")]),_vm._v(" "),_c('p',[_vm._v("EASY Flachdachabdichtung 1K wird direkt aus dem 7 kg Beutel verarbeitet. Inhalt kurz anrühren, auf die Fläche leeren und den Dichtstoff mit einem Roller oder Bürste bzw. einem breiten Pinsel in einer Stärke von 1 mm auftragen.")]),_vm._v(" "),_c('p',[_vm._v("Die erste Schicht muss ca. 3 Stunden bei 23°C und 50% relativer Luftfeuchtigkeit trocknen. In besonders rissgefährdeten oder beanspruchten Bereichen und Problemzonen empfehlen wir, proteXos Fleece in die noch feuchte Schicht mit einzuarbeiten.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col d-flex justify-content-center flex-column order-1 order-sm-2 mb-3 mb-sm-0"},[_c('h3',[_vm._v("Zweite Schicht auftragen")]),_vm._v(" "),_c('p',[_vm._v("EASY Flachdachabdichtung 1K wird direkt aus dem 7 kg Beutel verarbeitet. Inhalt kurz anrühren, auf die Fläche leeren und den Dichtstoff mit einem Roller oder Bürste bzw. einem breiten Pinsel in einer Stärke von 1 mm auftragen.")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("Der Flüssigkunststoff ist nach 12 Stunden bei 23°C und 50% relativer Luftfeuchtigkeit komplett ausgetrocknet. Das Material ist begehbar und es können nachfolgende Tätigkeiten aufgenommen werden. Temperaturschwankungen oder Änderungen der Luftfeuchtigkeit können zu Verzögerung der Aushärtung führen.")])])}]
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var views_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/views/Home.vue
function Home_injectStyle (ssrContext) {
  __webpack_require__("2Tf6")
}
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = Home_injectStyle
/* scopeId */
var Home___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  Home,
  views_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var src_views_Home = (Home_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a0c188e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Datenschutz.vue
var Datenschutz_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"mt-5"},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{ name: 'Home' }}},[_vm._v("Zurück")])],1),_vm._v(" "),_c('h1',{staticClass:"my-3"},[_vm._v("Datenschutz")]),_vm._v(" "),_c('h2',[_vm._v("1. Datenschutz auf einen Blick")]),_vm._v(" "),_c('h3',[_vm._v("Allgemeine Hinweise")]),_vm._v(" "),_c('p',[_vm._v("Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.")]),_vm._v(" "),_c('h3',[_vm._v("Datenerfassung auf unserer Website")]),_vm._v(" "),_c('h4',[_vm._v("Wer ist verantwortlich für die Datenerfassung auf dieser Website?")]),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('h4',[_vm._v("Wie erfassen wir Ihre Daten?")]),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_c('h4',[_vm._v("Wofür nutzen wir Ihre Daten?")]),_vm._v(" "),_c('p',[_vm._v("Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.")]),_vm._v(" "),_c('h4',[_vm._v("Welche Rechte haben Sie bezüglich Ihrer Daten?")]),_vm._v(" "),_c('p',[_vm._v("Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung, Sperrung oder Löschung dieser Daten zu verlangen. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.")]),_vm._v(" "),_c('h3',[_vm._v("Analyse-Tools und Tools von Drittanbietern")]),_vm._v(" "),_vm._m(2,false,false),_vm._v(" "),_c('h2',[_vm._v("2. Allgemeine Hinweise und Pflichtinformationen")]),_vm._v(" "),_c('h3',[_vm._v("Datenschutz")]),_vm._v(" "),_c('p',[_vm._v("Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.")]),_vm._v(" "),_c('p',[_vm._v("Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.")]),_vm._v(" "),_c('p',[_vm._v("Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.")]),_vm._v(" "),_c('h4',[_vm._v("Hinweis zur verantwortlichen Stelle")]),_vm._v(" "),_c('p',[_vm._v("Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:")]),_vm._v(" "),_vm._m(3,false,false),_vm._v(" "),_c('p',[_vm._v("Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, E-Mail-Adressen o. Ä.) entscheidet.")]),_vm._v(" "),_c('h3',[_vm._v("Widerruf Ihrer Einwilligung zur Datenverarbeitung")]),_vm._v(" "),_c('p',[_vm._v("Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.")]),_vm._v(" "),_c('h3',[_vm._v("Beschwerderecht bei der zuständigen Aufsichtsbehörde")]),_vm._v(" "),_vm._m(4,false,false),_vm._v(" "),_c('h3',[_vm._v("Recht auf Datenübertragbarkeit")]),_vm._v(" "),_c('p',[_vm._v("Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.")]),_vm._v(" "),_c('h3',[_vm._v("SSL- bzw. TLS-Verschlüsselung")]),_vm._v(" "),_c('p',[_vm._v("Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL-bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von \"http://\" auf \"https://\" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.")]),_vm._v(" "),_c('p',[_vm._v("Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.")]),_vm._v(" "),_c('h3',[_vm._v("Verschlüsselter Zahlungsverkehr auf dieser Website")]),_vm._v(" "),_c('p',[_vm._v("Besteht nach dem Abschluss eines kostenpflichtigen Vertrags eine Verpflichtung, uns Ihre Zahlungsdaten (z.B. Kontonummer bei Einzugsermächtigung) zu übermitteln, werden diese Daten zur Zahlungsabwicklung benötigt.")]),_vm._v(" "),_c('p',[_vm._v("Der Zahlungsverkehr über die gängigen Zahlungsmittel (Visa/MasterCard, Lastschriftverfahren) erfolgt ausschließlich über eine verschlüsselte SSL- bzw. TLS-Verbindung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von \"http://\" auf \"https://\" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile. Bei verschlüsselter Kommunikation können Ihre Zahlungsdaten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.")]),_vm._v(" "),_c('h3',[_vm._v("Auskunft, Sperrung, Löschung")]),_vm._v(" "),_c('p',[_vm._v("Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden.")]),_vm._v(" "),_c('h3',[_vm._v("Widerspruch gegen Werbe-Mails")]),_vm._v(" "),_c('p',[_vm._v("Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit widersprochen. Die Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-E-Mails, vor.")]),_vm._v(" "),_c('h2',[_vm._v("3. Datenschutzbeauftragter")]),_vm._v(" "),_c('h3',[_vm._v("Gesetzlich vorgeschriebener Datenschutzbeauftragter")]),_vm._v(" "),_c('p',[_vm._v("Wir haben für unser Unternehmen einen Datenschutzbeauftragten bestellt.")]),_vm._v(" "),_vm._m(5,false,false),_vm._v(" "),_c('h2',[_vm._v("4. Datenerfassung auf unserer Website")]),_vm._v(" "),_c('h3',[_vm._v("Cookies")]),_vm._v(" "),_c('p',[_vm._v("Die Internetseiten verwenden teilweise so genannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser speichert.")]),_vm._v(" "),_c('p',[_vm._v("Die meisten der von uns verwendeten Cookies sind so genannte \"Session-Cookies\". Sie werden nach Ende Ihres Besuchs automatisch gelöscht. Andere Cookies bleiben auf Ihrem Endgerät gespeichert bis Sie diese löschen. Diese Cookies ermöglichen es uns, Ihren Browser beim nächsten Besuch wiederzuerkennen.")]),_vm._v(" "),_c('p',[_vm._v("Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browser aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalität dieser Website eingeschränkt sein.")]),_vm._v(" "),_c('p',[_vm._v("Cookies, die zur Durchführung des elektronischen Kommunikationsvorgangs oder zur Bereitstellung bestimmter, von Ihnen erwünschter Funktionen (z.B. Warenkorbfunktion) erforderlich sind, werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert. Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von Cookies zur technisch fehlerfreien und optimierten Bereitstellung seiner Dienste. Soweit andere Cookies (z.B. Cookies zur Analyse Ihres Surfverhaltens) gespeichert werden, werden diese in dieser Datenschutzerklärung gesondert behandelt.")]),_vm._v(" "),_c('h3',[_vm._v("Server-Log-Dateien")]),_vm._v(" "),_c('p',[_vm._v("Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:")]),_vm._v(" "),_vm._m(6,false,false),_vm._v(" "),_c('p',[_vm._v("Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.")]),_vm._v(" "),_c('p',[_vm._v("Grundlage für die Datenverarbeitung ist Art. 6 Abs. 1 lit. f DSGVO, der die Verarbeitung von Daten zur Erfüllung eines Vertrags oder vorvertraglicher Maßnahmen gestattet.")]),_vm._v(" "),_c('h3',[_vm._v("Kontaktformular")]),_vm._v(" "),_c('p',[_vm._v("Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.")]),_vm._v(" "),_c('p',[_vm._v("Die Verarbeitung der in das Kontaktformular eingegebenen Daten erfolgt somit ausschließlich auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Sie können diese Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt.")]),_vm._v(" "),_c('p',[_vm._v("Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z.B. nach abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen – bleiben unberührt.")]),_vm._v(" "),_c('h3',[_vm._v("Registrierung auf dieser Website")]),_vm._v(" "),_c('p',[_vm._v("Sie können sich auf unserer Website registrieren, um zusätzliche Funktionen auf der Seite zu nutzen. Die dazu eingegebenen Daten verwenden wir nur zum Zwecke der Nutzung des jeweiligen Angebotes oder Dienstes, für den Sie sich registriert haben. Die bei der Registrierung abgefragten Pflichtangaben müssen vollständig angegeben werden. Anderenfalls werden wir die Registrierung ablehnen.")]),_vm._v(" "),_c('p',[_vm._v("Für wichtige Änderungen etwa beim Angebotsumfang oder bei technisch notwendigen Änderungen nutzen wir die bei der Registrierung angegebene E-Mail-Adresse, um Sie auf diesem Wege zu informieren.")]),_vm._v(" "),_c('p',[_vm._v("Die Verarbeitung der bei der Registrierung eingegebenen Daten erfolgt auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Sie können eine von Ihnen erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bereits erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.")]),_vm._v(" "),_c('p',[_vm._v("Die bei der Registrierung erfassten Daten werden von uns gespeichert, solange Sie auf unserer Website registriert sind und werden anschließend gelöscht. Gesetzliche Aufbewahrungsfristen bleiben unberührt.")]),_vm._v(" "),_c('h3',[_vm._v("Kommentarfunktion auf dieser Website")]),_vm._v(" "),_c('p',[_vm._v("Für die Kommentarfunktion auf dieser Seite werden neben Ihrem Kommentar auch Angaben zum Zeitpunkt der Erstellung des Kommentars und, wenn Sie nicht anonym posten, der von Ihnen gewählte Nutzername gespeichert.")]),_vm._v(" "),_c('h4',[_vm._v("Speicherung der IP-Adresse")]),_vm._v(" "),_c('p',[_vm._v("Unsere Kommentarfunktion speichert die IP-Adressen der Nutzer, die Kommentare verfassen. Da wir Kommentare auf unserer Seite nicht vor der Freischaltung prüfen, benötigen wir diese Daten, um im Falle von Rechtsverletzungen wie Beleidigungen oder Propaganda gegen den Verfasser vorgehen zu können.")]),_vm._v(" "),_c('h4',[_vm._v("Speicherdauer der Kommentare")]),_vm._v(" "),_c('p',[_vm._v("Die Kommentare und die damit verbundenen Daten (z.B. IP-Adresse) werden gespeichert und verbleiben auf unserer Website, bis der kommentierte Inhalt vollständig gelöscht wurde oder die Kommentare aus rechtlichen Gründen gelöscht werden müssen (z.B. beleidigende Kommentare).")]),_vm._v(" "),_c('h4',[_vm._v("Rechtsgrundlage")]),_vm._v(" "),_c('p',[_vm._v("Die Speicherung der Kommentare erfolgt auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Sie können eine von Ihnen erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bereits erfolgten Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt.")]),_vm._v(" "),_c('h3',[_vm._v("Verarbeiten von Daten (Kunden- und Vertragsdaten)")]),_vm._v(" "),_c('p',[_vm._v("Wir erheben, verarbeiten und nutzen personenbezogene Daten nur, soweit sie für die Begründung, inhaltliche Ausgestaltung oder Änderung des Rechtsverhältnisses erforderlich sind (Bestandsdaten). Dies erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, der die Verarbeitung von Daten zur Erfüllung eines Vertrags oder vorvertraglicher Maßnahmen gestattet. Personenbezogene Daten über die Inanspruchnahme unserer Internetseiten (Nutzungsdaten) erheben, verarbeiten und nutzen wir nur, soweit dies erforderlich ist, um dem Nutzer die Inanspruchnahme des Dienstes zu ermöglichen oder abzurechnen.")]),_vm._v(" "),_c('p',[_vm._v("Die erhobenen Kundendaten werden nach Abschluss des Auftrags oder Beendigung der Geschäftsbeziehung gelöscht. Gesetzliche Aufbewahrungsfristen bleiben unberührt.")]),_vm._v(" "),_c('h3',[_vm._v("Datenübermittlung bei Vertragsschluss für Online-Shops, Händler und Warenversand")]),_vm._v(" "),_vm._m(7,false,false),_vm._v(" "),_c('h2',[_vm._v("5. Analyse Tools und Werbung")]),_vm._v(" "),_c('h3',[_vm._v("Google Analytics")]),_vm._v(" "),_c('p',[_vm._v("Diese Website nutzt Funktionen des Webanalysedienstes Google Analytics. Anbieter ist die Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.")]),_vm._v(" "),_c('p',[_vm._v("Google Analytics verwendet so genannte \"Cookies\". Das sind Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie ermöglichen. Die durch den Cookie erzeugten Informationen über Ihre Benutzung dieser Website werden in der Regel an einen Server von Google in den USA übertragen und dort gespeichert.")]),_vm._v(" "),_c('p',[_vm._v("Die Speicherung von Google-Analytics-Cookies erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der Analyse des Nutzerverhaltens, um sowohl sein Webangebot als auch seine Werbung zu optimieren.")]),_vm._v(" "),_c('h3',[_vm._v("Einsatz von Matomo")]),_vm._v(" "),_vm._m(8,false,false),_vm._v(" "),_c('p',[_vm._v("Die durch das Cookie erzeugten Informationen im pseudonymen Nutzerprofil werden nicht dazu benutzt, den Besucher dieser Website persönlich zu identifizieren und nicht mit personenbezogenen Daten über den Träger des Pseudonyms zusammengeführt. Wenn Sie mit der Speicherung und Auswertung dieser Daten aus Ihrem Besuch nicht einverstanden sind, dann können Sie der Speicherung und Nutzung nachfolgend per Mausklick jederzeit widersprechen. In diesem Fall wird in Ihrem Browser ein sog. Opt-Out-Cookie abgelegt, was zur Folge hat, dass Matomo keinerlei Sitzungsdaten erhebt. Bitte beachten Sie, dass die vollständige Löschung Ihrer Cookies zur Folge hat, dass auch das Opt-Out-Cookie gelöscht wird und ggf. von Ihnen erneut aktiviert werden muss.")]),_vm._v(" "),_c('iframe',{staticStyle:{"border":"0","height":"200px","width":"600px"},attrs:{"src":"http://pw.alfa-direkt.de/index.php?module=CoreAdminHome&action=optOut&language=de&backgroundColor=&fontColor=&fontSize=&fontFamily="}}),_vm._v(" "),_c('h3',[_vm._v("IP Anonymisierung")]),_vm._v(" "),_c('p',[_vm._v("Wir haben auf dieser Website die Funktion IP-Anonymisierung aktiviert. Dadurch wird Ihre IP-Adresse von Google innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum vor der Übermittlung in die USA gekürzt. Nur in Ausnahmefällen wird die volle IP-Adresse an einen Server von Google in den USA übertragen und dort gekürzt. Im Auftrag des Betreibers dieser Website wird Google diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports über die Websiteaktivitäten zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen gegenüber dem Websitebetreiber zu erbringen. Die im Rahmen von Google Analytics von Ihrem Browser übermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengeführt.")]),_vm._v(" "),_c('h3',[_vm._v("Browser Plugin")]),_vm._v(" "),_vm._m(9,false,false),_vm._v(" "),_vm._m(10,false,false),_vm._v(" "),_c('h3',[_vm._v("Auftragsdatenverarbeitung")]),_vm._v(" "),_c('p',[_vm._v("Wir haben mit Google einen Vertrag zur Auftragsdatenverarbeitung abgeschlossen und setzen die strengen Vorgaben der deutschen Datenschutzbehörden bei der Nutzung von Google Analytics vollständig um.")]),_vm._v(" "),_c('h3',[_vm._v("Google AdWords und Google Conversion-Tracking")]),_vm._v(" "),_c('p',[_vm._v("Diese Website verwendet Google AdWords. AdWords ist ein Online-Werbeprogramm der Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, United States (\"Google\").")]),_vm._v(" "),_c('p',[_vm._v("Im Rahmen von Google AdWords nutzen wir das so genannte Conversion-Tracking. Wenn Sie auf eine von Google geschaltete Anzeige klicken wird ein Cookie für das Conversion-Tracking gesetzt. Bei Cookies handelt es sich um kleine Textdateien, die der Internet-Browser auf dem Computer des Nutzers ablegt. Diese Cookies verlieren nach 30 Tagen ihre Gültigkeit und dienen nicht der persönlichen Identifizierung der Nutzer. Besucht der Nutzer bestimmte Seiten dieser Website und das Cookie ist noch nicht abgelaufen, können Google und wir erkennen, dass der Nutzer auf die Anzeige geklickt hat und zu dieser Seite weitergeleitet wurde.")]),_vm._v(" "),_c('p',[_vm._v("Jeder Google AdWords-Kunde erhält ein anderes Cookie. Die Cookies können nicht über die Websites von AdWords-Kunden nachverfolgt werden. Die mithilfe des Conversion-Cookies eingeholten Informationen dienen dazu, Conversion-Statistiken für AdWords-Kunden zu erstellen, die sich für Conversion-Tracking entschieden haben. Die Kunden erfahren die Gesamtanzahl der Nutzer, die auf ihre Anzeige geklickt haben und zu einer mit einem Conversion-Tracking-Tag versehenen Seite weitergeleitet wurden. Sie erhalten jedoch keine Informationen, mit denen sich Nutzer persönlich identifizieren lassen. Wenn Sie nicht am Tracking teilnehmen möchten, können Sie dieser Nutzung widersprechen, indem Sie das Cookie des Google Conversion-Trackings über ihren Internet-Browser unter Nutzereinstellungen leicht deaktivieren. Sie werden sodann nicht in die Conversion-Tracking Statistiken aufgenommen.")]),_vm._v(" "),_c('p',[_vm._v("Die Speicherung von \"Conversion-Cookies\" erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der Analyse des Nutzerverhaltens, um sowohl sein Webangebot als auch seine Werbung zu optimieren.")]),_vm._v(" "),_vm._m(11,false,false),_vm._v(" "),_c('p',[_vm._v("Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browser aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalität dieser Website eingeschränkt sein.")]),_vm._v(" "),_c('h3',[_vm._v("Facebook Pixel")]),_vm._v(" "),_c('p',[_vm._v("Unsere Website nutzt zur Konversionsmessung das Besucheraktions-Pixel von Facebook, Facebook Inc., 1601 S. California Ave, Palo Alto, CA 94304, USA (\"Facebook\").")]),_vm._v(" "),_c('p',[_vm._v("So kann das Verhalten der Seitenbesucher nachverfolgt werden, nachdem diese durch Klick auf eine Facebook-Werbeanzeige auf die Website des Anbieters weitergeleitet wurden. Dadurch können die Wirksamkeit der Facebook-Werbeanzeigen für statistische und Marktforschungszwecke ausgewertet werden und zukünftige Werbemaßnahmen optimiert werden.")]),_vm._v(" "),_c('p',[_vm._v("Die erhobenen Daten sind für uns als Betreiber dieser Website anonym, wir können keine Rückschlüsse auf die Identität der Nutzer ziehen. Die Daten werden aber von Facebook gespeichert und verarbeitet, sodass eine Verbindung zum jeweiligen Nutzerprofil möglich ist und Facebook die Daten für eigene Werbezwecke, entsprechend der Facebook-Datenverwendungsrichtlinie verwenden kann. Dadurch kann Facebook das Schalten von Werbeanzeigen auf Seiten von Facebook sowie außerhalb von Facebook ermöglichen. Diese Verwendung der Daten kann von uns als Seitenbetreiber nicht beeinflusst werden.")]),_vm._v(" "),_vm._m(12,false,false),_vm._v(" "),_vm._m(13,false,false),_vm._v(" "),_c('h2',[_vm._v("6. Plugins und Tools")]),_vm._v(" "),_c('h3',[_vm._v("YouTube")]),_vm._v(" "),_vm._m(14,false,false),_c('p'),_c('p',[_vm._v("Wenn Sie in Ihrem YouTube-Account eingeloggt sind, ermöglichen Sie YouTube, Ihr Surfverhalten direkt Ihrem persönlichen Profil zuzuordnen. Dies können Sie verhindern, indem Sie sich aus Ihrem YouTube-Account ausloggen.")]),_vm._v(" "),_c('p',[_vm._v("Die Nutzung von YouTube erfolgt im Interesse einer ansprechenden Darstellung unserer Online-Angebote. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.")]),_vm._v(" "),_vm._m(15,false,false),_vm._v(" "),_c('h3',[_vm._v("Google Web Fonts")]),_vm._v(" "),_c('p',[_vm._v("Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten so genannte Web Fonts, die von Google bereitgestellt werden. Beim Aufruf einer Seite lädt Ihr Browser die benötigten Web Fonts in ihren Browsercache, um Texte und Schriftarten korrekt anzuzeigen.")]),_vm._v(" "),_c('p',[_vm._v("Zu diesem Zweck muss der von Ihnen verwendete Browser Verbindung zu den Servern von Google aufnehmen. Hierdurch erlangt Google Kenntnis darüber, dass über Ihre IP-Adresse unsere Website aufgerufen wurde. Die Nutzung von Google Web Fonts erfolgt im Interesse einer einheitlichen und ansprechenden Darstellung unserer Online-Angebote. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.")]),_vm._v(" "),_c('p',[_vm._v("Wenn Ihr Browser Web Fonts nicht unterstützt, wird eine Standardschrift von Ihrem Computer genutzt.")]),_vm._v(" "),_vm._m(16,false,false),_vm._v(" "),_c('h3',[_vm._v("Live-Chat über LiveAgent")]),_vm._v(" "),_vm._m(17,false,false)])])])}
var Datenschutz_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem "),_c('a',{attrs:{"href":"https://www.alfa-direkt.de/impressum"}},[_vm._v("Impressum")]),_vm._v(" dieser Website entnehmen.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben."),_c('br'),_vm._v("\n            Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie unsere Website betreten.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Beim Besuch unserer Website kann Ihr Surf-Verhalten statistisch ausgewertet werden. Das geschieht vor allem mit Cookies und mit sogenannten Analyseprogrammen. Die Analyse Ihres Surf-Verhaltens erfolgt in der Regel anonym; das Surf-Verhalten kann nicht zu Ihnen zurückverfolgt werden. Sie können dieser Analyse widersprechen oder sie durch die Nichtbenutzung bestimmter Tools verhindern. Detaillierte Informationen dazu finden Sie in der folgenden Datenschutzerklärung."),_c('br'),_vm._v("\n            Sie können dieser Analyse widersprechen. Über die Widerspruchsmöglichkeiten werden wir Sie in dieser Datenschutzerklärung informieren.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"well"},[_vm._v("\n                Alfa GmbH "),_c('br'),_vm._v("\n                Arne Kochler"),_c('br'),_vm._v("\n                Ferdinand-Porsche-Str. 10"),_c('br'),_vm._v("\n                73479 Ellwangen"),_c('br'),_vm._v("\n                Deutschland"),_c('br'),_c('br'),_vm._v("\n                Telefon: +49 (0) 7961 5799-0"),_c('br'),_vm._v("\n                E-Mail: "),_c('a',{attrs:{"href":"mailto:info@alfa-direkt.de"}},[_vm._v("info@alfa-direkt.de")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Im Falle datenschutzrechtlicher Verstöße steht dem Betroffenen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu. Zuständige Aufsichtsbehörde in datenschutzrechtlichen Fragen ist der Landesdatenschutzbeauftragte des Bundeslandes, in dem unser Unternehmen seinen Sitz hat. Eine Liste der Datenschutzbeauftragten sowie deren Kontaktdaten können folgendem Link entnommen werden: "),_c('a',{attrs:{"href":"https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html","target":"_blank"}},[_vm._v("https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"well"},[_vm._v("\n                IPEXX Systems GmbH & Co KG"),_c('br'),_vm._v("\n                Industriestraße 14"),_c('br'),_vm._v("\n                91637 Wörnitz"),_c('br'),_vm._v("\n                E-Mail: datenschutz@alfa-direkt.de\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Browsertyp und Browserversion")]),_vm._v(" "),_c('li',[_vm._v("verwendetes Betriebssystem")]),_vm._v(" "),_c('li',[_vm._v("Referrer URL")]),_vm._v(" "),_c('li',[_vm._v("Hostname des zugreifenden Rechners")]),_vm._v(" "),_c('li',[_vm._v("Uhrzeit der Serveranfrage")]),_vm._v(" "),_c('li',[_vm._v("IP-Adresse")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Wir übermitteln personenbezogene Daten an Dritte nur dann, wenn dies im Rahmen der Vertragsabwicklung notwendig ist, etwa an die mit der Lieferung der Ware betrauten Unternehmen oder das mit der Zahlungsabwicklung beauftragte Kreditinstitut. Eine weitergehende Übermittlung der Daten erfolgt nicht bzw. nur dann, wenn Sie der Übermittlung ausdrücklich zugestimmt haben. Eine Weitergabe Ihrer Daten an Dritte ohne ausdrückliche Einwilligung, etwa zu Zwecken der Werbung, erfolgt nicht."),_c('br'),_vm._v("\n            Grundlage für die Datenverarbeitung ist Art. 6 Abs. 1 lit. b DSGVO, der die Verarbeitung von Daten zur Erfüllung eines Vertrags oder vorvertraglicher Maßnahmen gestattet.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Auf dieser Website werden unter Einsatz der Webanalysedienst-Software Matomo ("),_c('a',{attrs:{"href":"https://www.matomo.org","target":"_blank"}},[_vm._v("www.matomo.org")]),_vm._v("), einem Dienst des Anbieters InnoCraft Ltd., 150 Willis St, 6011 Wellington, Neuseeland, („Matomo\") auf Basis unseres berechtigten Interesses an der statistischen Analyse des Nutzerverhaltens zu Optimierungs- und Marketingzwecken gemäß Art. 6 Abs. 1 lit. f DSGVO Daten gesammelt und gespeichert. Aus diesen Daten können zum selben Zweck pseudonymisierte Nutzungsprofile erstellt und ausgewertet werden. Hierzu können Cookies eingesetzt werden. Bei Cookies handelt es sich um kleine Textdateien, die lokal im Zwischenspeicher des Internet-Browsers des Seitenbesuchers gespeichert werden. Die Cookies ermöglichen unter anderem die Wiedererkennung des Internet-Browsers. Die mit der Matomo-Technologie erhobenen Daten (einschließlich Ihrer pseudonymisierten IP-Adresse) werden auf unseren Servern verarbeitet.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Sie können die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser Website vollumfänglich werden nutzen können. Sie können darüber hinaus die Erfassung der durch den Cookie erzeugten und auf Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem Sie das unter dem folgenden Link verfügbare Browser-Plugin herunterladen und installieren: "),_c('a',{attrs:{"href":"https://tools.google.com/dlpage/gaoptout?hl=de","target":"_blank"}},[_vm._v("https://tools.google.com/dlpage/gaoptout?hl=de")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Mehr Informationen zum Umgang mit Nutzerdaten bei Google Analytics finden Sie in der Datenschutzerklärung von Google: "),_c('a',{attrs:{"href":"https://support.google.com/analytics/answer/6004245?hl=de","target":"_blank"}},[_vm._v("https://support.google.com/analytics/answer/6004245?hl=de")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Mehr Informationen zu Google AdWords und Google Conversion-Tracking finden Sie in den Datenschutzbestimmungen von Google: "),_c('a',{attrs:{"href":"https://www.google.de/policies/privacy/"}},[_vm._v("https://www.google.de/policies/privacy")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("In den Datenschutzhinweisen von Facebook finden Sie weitere Hinweise zum Schutz Ihrer Privatsphäre: "),_c('a',{attrs:{"href":"https://www.facebook.com/about/privacy/","target":"_blank"}},[_vm._v("https://www.facebook.com/about/privacy/")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Sie können außerdem die Remarketing-Funktion \"Custom Audiences\" im Bereich Einstellungen für Werbeanzeigen unter "),_c('a',{attrs:{"href":"https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen","target":"_blank"}},[_vm._v("https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen")]),_vm._v(" deaktivieren. Dazu müssen Sie bei Facebook angemeldet sein.\n            Wenn Sie kein Facebook Konto besitzen, können Sie nutzungsbasierte Werbung von Facebook auf der Website der European Interactive Digital Advertising Alliance deaktivieren: "),_c('a',{attrs:{"href":"http://www.youronlinechoices.com/de/praferenzmanagement/","target":"_blank"}},[_vm._v("http://www.youronlinechoices.com/de/praferenzmanagement/.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Unsere Website nutzt Plugins der von Google betriebenen Seite YouTube. Betreiber der Seiten ist die YouTube, LLC, 901 Cherry Ave., San Bruno, CA 94066, USA."),_c('br'),_vm._v("\n            Wenn Sie eine unserer mit einem YouTube-Plugin ausgestatteten Seiten besuchen, wird eine Verbindung zu den Servern von YouTube hergestellt. Dabei wird dem YouTube-Server mitgeteilt, welche unserer Seiten Sie besucht haben.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Weitere Informationen zum Umgang mit Nutzerdaten finden Sie in der Datenschutzerklärung von YouTube unter: "),_c('a',{attrs:{"href":"https://www.google.de/intl/de/policies/privacy","target":"_blank"}},[_vm._v("https://www.google.de/intl/de/policies/privacy")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Weitere Informationen zu Google Web Fonts finden Sie unter "),_c('a',{attrs:{"href":"https://developers.google.com/fonts/faq","target":"_blank"}},[_vm._v("https://developers.google.com/fonts/faq")]),_vm._v(" und in der Datenschutzerklärung von Google: "),_c('a',{attrs:{"href":"https://www.google.com/policies/privacy/","target":"_blank"}},[_vm._v("https://www.google.com/policies/privacy/")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Auf einigen unserer Seiten unterstützen wir unsere Kunden mit einem Chat. Dieser Chat wird von LiveAgent (https://www.ladesk.com/) bereitgestellt. Um begonnene Gespräche auch zu einem späteren Zeitpunkt weiterführen zu können, werden von Zendesk Cookies gesetzt. Hierbei handelt es sich um funktionelle Cookies zur Nutzung des Chattools. Weitergehende Informationen zum Datenschutz bei Zendesk erhalten Sie hier: "),_c('a',{attrs:{"href":"https://www.ladesk.com/gdpr/","target":"_blank"}},[_vm._v("https://www.ladesk.com/gdpr/")])])}]
var Datenschutz_esExports = { render: Datenschutz_render, staticRenderFns: Datenschutz_staticRenderFns }
/* harmony default export */ var Datenschutz = (Datenschutz_esExports);
// CONCATENATED MODULE: ./src/views/Datenschutz.vue
var Datenschutz_normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var Datenschutz___vue_template_functional__ = false
/* styles */
var Datenschutz___vue_styles__ = null
/* scopeId */
var Datenschutz___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Datenschutz___vue_module_identifier__ = null
var Datenschutz_Component = Datenschutz_normalizeComponent(
  __vue_script__,
  Datenschutz,
  Datenschutz___vue_template_functional__,
  Datenschutz___vue_styles__,
  Datenschutz___vue_scopeId__,
  Datenschutz___vue_module_identifier__
)

/* harmony default export */ var views_Datenschutz = (Datenschutz_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: src_views_Home
  }, {
    path: '/datenschutz',
    name: 'Datenschutz',
    component: views_Datenschutz
  }]
}));
// EXTERNAL MODULE: ./node_modules/vuex-persistedstate/dist/vuex-persistedstate.es.js
var vuex_persistedstate_es = __webpack_require__("424j");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/content/flachdach.js


var _default$angebot1$ga;

/* eslint-disable */

/* harmony default export */ var flachdach = (_default$angebot1$ga = {
  default: {
    h1Text: 'Kinderleicht zu verarbeitende Flachdachabdichtung',
    leadText: 'Inklusive 5 Jahre Gewährleistung',
    objectText: 'Flachdach'
  },
  'angebot-1': {
    h1Text: 'Kinderleicht zu verarbeitende Flachdachabdichtung',
    leadText: 'Jetzt Angebot nutzen und 20% sparen',
    objectText: 'Flachdach'
  },
  'garagendach abdichten': {
    h1Text: 'Garagendach undicht?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihre Garage wieder dicht!',
    objectText: 'Garagendach'
  },
  'garagendach sanieren': {
    h1Text: 'Garagendach undicht?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihre Garage wieder dicht!',
    objectText: 'Garagendach'
  },
  'garagendach abdichten flüssigkunststoff': {
    h1Text: 'Garagendach undicht?',
    leadText: 'Mit unserem EASY Flüssigkunststoff wird auch Ihre Garage wieder dicht!',
    objectText: 'Garagendach'
  },
  'flachdachabdichtung garage': {
    h1Text: 'Garagendach undicht?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihre Garage wieder dicht!',
    objectText: 'Garagendach'
  },
  'terrassenabdichtung': {
    h1Text: 'Terasse abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihre Terasse wieder dicht!',
    objectText: 'Terrasse'
  },
  'terrasse abdichten': {
    h1Text: 'Terasse abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihre Terasse wieder dicht!',
    objectText: 'Terrasse'
  },
  'terrassenabdichtung mit flüssigkunststoff': {
    h1Text: 'Terasse abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihre Terasse wieder dicht!',
    objectText: 'Terrasse'
  },
  'dachterrasse abdichten': {
    h1Text: 'Terasse abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihre Terasse wieder dicht!',
    objectText: 'Terrasse'
  },
  'terrassenabdichtung flüssigkunststoff preise': {
    h1Text: 'Terasse abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihre Terasse wieder dicht!',
    objectText: 'Terrasse'
  },
  'flüssigabdichtung terrasse': {
    h1Text: 'Terasse abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihre Terasse wieder dicht!',
    objectText: 'Terrasse'
  },
  'terasse abdichten': {
    h1Text: 'Terasse abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihre Terasse wieder dicht!',
    objectText: 'Terrasse'
  },
  'carport dach abdichten': {
    h1Text: 'Carport abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Carport wieder dicht!',
    objectText: 'Carport'
  },
  'balkonabdichtung': {
    h1Text: 'Balkon abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Balkon wieder dicht!',
    objectText: 'Balkon'
  },
  'flüssigkunststoff balkon': {
    h1Text: 'Balkon abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Balkon wieder dicht!',
    objectText: 'Balkon'
  },
  'balkon abdichten': {
    h1Text: 'Balkon abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Balkon wieder dicht!',
    objectText: 'Balkon'
  },
  'flüssigkunststoff balkon test': {
    h1Text: 'Balkon abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Balkon wieder dicht!',
    objectText: 'Balkon'
  },
  'dachabdichtung': {
    h1Text: 'Dach abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Dach wieder dicht!',
    objectText: 'Dach'
  },
  'dach abdichten': {
    h1Text: 'Dach abdichten?',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Dach wieder dicht!',
    objectText: 'Dach'
  },
  'flüssige dachabdichtung': {
    h1Text: 'Dach abdichten?',
    leadText: 'Mit unserer EASY Dachabdichtung wird auch Ihr Dach wieder dicht!',
    objectText: 'Dach'
  },
  'dachabdichtung flüssigkunststoff': {
    h1Text: 'Dach abdichten?',
    leadText: 'Mit unserer EASY Dachabdichtung wird auch Ihr Dach wieder dicht!',
    objectText: 'Dach'
  },
  'dachabdichtung flüssig': {
    h1Text: 'Flüssige Dachabdichtung',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Dach wieder dicht!',
    objectText: 'Dach'
  },
  'flüssigkunststoff dachabdichtung': {
    h1Text: 'Flüssige Dachabdichtung',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Dach wieder dicht!',
    objectText: 'Dach'
  },
  'flüssigkunststoff dach kaufen': {
    h1Text: 'Flüssige Dachabdichtung',
    leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Dach wieder dicht!',
    objectText: 'Dach'
  },
  'dachdicht': {
    h1Text: 'Dach abdichten?',
    leadText: 'Mit unserer EASY Dachabdichtung wird auch Ihr Dach wieder dicht!',
    objectText: 'Dach'
  },
  'holzdach abdichten': {
    h1Text: 'Holzdach abdichten?',
    leadText: 'Mit unserer EASY Dachabdichtung wird auch Ihr Dach wieder dicht!',
    objectText: 'Holzdach'
  },
  'dach beschichten': {
    h1Text: 'Dach abdichten?',
    leadText: 'Mit unserer EASY Dachabdichtung wird auch Ihr Dach wieder dicht!',
    objectText: 'Dach'
  }
}, defineProperty_default()(_default$angebot1$ga, 'fl\xFCssigkunststoff balkon test', {
  h1Text: 'Balkon abdichten?',
  leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Balkon wieder dicht!',
  objectText: 'Balkon'
}), defineProperty_default()(_default$angebot1$ga, 'flachdachabdichtung', {
  h1Text: 'Flachdach abdichten?',
  leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
  objectText: 'Flachdach'
}), defineProperty_default()(_default$angebot1$ga, 'flachdach abdichten', {
  h1Text: 'Flachdach abdichten?',
  leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
  objectText: 'Flachdach'
}), defineProperty_default()(_default$angebot1$ga, 'flüssigkunststoff dach', {
  h1Text: 'Flachdach abdichten?',
  leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
  objectText: 'Flachdach'
}), defineProperty_default()(_default$angebot1$ga, 'flüssigabdichtung', {
  h1Text: 'Flachdach abdichten?',
  leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
  objectText: 'Flachdach'
}), defineProperty_default()(_default$angebot1$ga, 'flachdach abdichtung', {
  h1Text: 'Flachdach abdichten?',
  leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
  objectText: 'Flachdach'
}), defineProperty_default()(_default$angebot1$ga, 'flachdach abdichten flüssigkunststoff', {
  h1Text: 'Flachdach abdichten?',
  leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
  objectText: 'Flachdach'
}), defineProperty_default()(_default$angebot1$ga, 'dachabdichtung flachdach', {
  h1Text: 'Flachdach abdichten?',
  leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
  objectText: 'Flachdach'
}), defineProperty_default()(_default$angebot1$ga, 'flachdach sanieren', {
  h1Text: 'Flachdach abdichten?',
  leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
  objectText: 'Flachdach'
}), defineProperty_default()(_default$angebot1$ga, 'flüssigkunststoff flachdach', {
  h1Text: 'Flachdach abdichten?',
  leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
  objectText: 'Flachdach'
}), defineProperty_default()(_default$angebot1$ga, 'flachdach abdichten flüssig', {
  h1Text: 'Flachdach abdichten?',
  leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
  objectText: 'Flachdach'
}), defineProperty_default()(_default$angebot1$ga, 'flüssigkunststoff für flachdach kaufen', {
  h1Text: 'Flachdach abdichten?',
  leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
  objectText: 'Flachdach'
}), defineProperty_default()(_default$angebot1$ga, 'abdichtung flachdach', {
  h1Text: 'Flachdach abdichten?',
  leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
  objectText: 'Flachdach'
}), defineProperty_default()(_default$angebot1$ga, 'flüssigkunststoff flachdach preis', {
  h1Text: 'Flachdach abdichten?',
  leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
  objectText: 'Flachdach'
}), defineProperty_default()(_default$angebot1$ga, 'flachdach abdichten', {
  h1Text: 'Flachdach abdichten?',
  leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
  objectText: 'Flachdach'
}), defineProperty_default()(_default$angebot1$ga, 'flachdachabdichtung flüssigkunststoff', {
  h1Text: 'Flachdach abdichten?',
  leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
  objectText: 'Flachdach'
}), defineProperty_default()(_default$angebot1$ga, 'flachdach flüssigkunststoff', {
  h1Text: 'Flachdach abdichten?',
  leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
  objectText: 'Flachdach'
}), defineProperty_default()(_default$angebot1$ga, 'flachdachsanierung mit flüssigkunststoff', {
  h1Text: 'Flachdach abdichten?',
  leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
  objectText: 'Flachdach'
}), defineProperty_default()(_default$angebot1$ga, 'alfa easy flachdachabdichtung', {
  h1Text: 'Flachdach abdichten?',
  leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
  objectText: 'Flachdach'
}), defineProperty_default()(_default$angebot1$ga, 'easy flachdachabdichtung 1k', {
  h1Text: 'Flachdach abdichten?',
  leadText: 'Mit unserer EASY Flachdachabdichtung wird auch Ihr Flachdach wieder dicht!',
  objectText: 'Flachdach'
}), _default$angebot1$ga);
// CONCATENATED MODULE: ./src/content/index.js


/* harmony default export */ var content = ({
  flachdach: flachdach
});
// CONCATENATED MODULE: ./src/store/index.js





vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var state = {
  keyword: '',
  content: content,
  user: {
    visitCount: 0,
    calculator: {
      length: 6,
      width: 3,
      fleece: false
    },
    isB2B: false,
    playedVideo: false
  }
};

var getters = {
  getContent: function getContent(state) {
    return function (page, keyword) {
      if (typeof keyword === 'undefined') {
        return state.content[page].default;
      }
      if (typeof state.content[page][keyword] === 'undefined') {
        return state.content[page].default;
      }
      return state.content[page][keyword];
    };
  },
  visitCount: function visitCount(state) {
    return state.user.visitCount;
  },
  playedVideo: function playedVideo(state) {
    return state.user.playedVideo;
  },
  getCalculator: function getCalculator(state) {
    return state.user.calculator;
  },
  isB2B: function isB2B(state) {
    return state.user.isB2B;
  },
  keyword: function keyword(state) {
    return state.keyword;
  }
};

var mutations = {
  INCREMENT_VISIT_COUNT: function INCREMENT_VISIT_COUNT(state) {
    state.user.visitCount++;
  },
  SET_PLAYED_VIDEO_TRUE: function SET_PLAYED_VIDEO_TRUE(state) {
    state.user.playedVideo = true;
  },
  USER_IS_B2B: function USER_IS_B2B(state, boolean) {
    state.user.isB2B = boolean;
  },
  SAVE_CALCULATOR: function SAVE_CALCULATOR(state, formData) {
    state.user.calculator = formData;
  },
  SET_KEYWORD: function SET_KEYWORD(state, keyword) {
    state.keyword = keyword;
  }
};

var actions = {
  viewPage: function viewPage(_ref) {
    var commit = _ref.commit;

    commit('INCREMENT_VISIT_COUNT');
  },
  playVideo: function playVideo(_ref2) {
    var commit = _ref2.commit;

    commit('SET_PLAYED_VIDEO_TRUE');
  },
  b2bUser: function b2bUser(_ref3, boolean) {
    var commit = _ref3.commit;

    commit('USER_IS_B2B', boolean);
  },
  saveCalculator: function saveCalculator(_ref4, formData) {
    var commit = _ref4.commit;

    commit('SAVE_CALCULATOR', formData);
  },
  setKeyword: function setKeyword(_ref5, keyword) {
    var commit = _ref5.commit;

    commit('SET_KEYWORD', keyword);
  }
};

var store = new vuex_esm["a" /* default */].Store({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
  plugins: [Object(vuex_persistedstate_es["a" /* default */])()]
});

/* harmony default export */ var src_store = (store);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Calculator.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Calculator = ({
  data: function data() {
    return {
      flachdachSet: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getCalculator', 'isB2B']), {
    squareMeter: function squareMeter() {
      var squareMeter = 0;

      if (this.getCalculator.length > 0 && this.getCalculator.width > 0) {
        squareMeter = Math.round(this.getCalculator.length * this.getCalculator.width * 100) / 100;
      }

      return squareMeter;
    },
    consumption: function consumption() {
      var consumption = Math.round(this.squareMeter * this.thickness * 100) / 100 * 2;

      return consumption.toString().replace('.', ',');
    },
    thickness: function thickness() {
      var thickness = 1.4;

      if (this.getCalculator.fleece) {
        thickness = 2;
      }

      return thickness;
    },
    formData: function formData() {
      return {
        width: this.getCalculator.width,
        length: this.getCalculator.length,
        squareMeter: this.squareMeter,
        fleece: this.getCalculator.fleece
      };
    },
    user: function user() {
      return this.$store.state.user;
    },
    CTAText: function CTAText() {
      if (this.isB2B) {
        return 'Bei Alfa Direkt bestellen';
      }
      return 'Bei Heimwerker Direkt bestellen';
    },
    CTAURL: function CTAURL() {
      if (this.isB2B) {
        if (this.flachdachSet === true) {
          return 'https://www.alfa-direkt.de/804-alfa-flachdachabdichtung-set-mit-vlies';
        }
        return 'https://www.alfa-direkt.de/805-alfa-easy-flachdachabdichtung-1k';
      }
      if (this.flachdachSet === true) {
        return 'https://www.heimwerker-direkt.de/flachdachabdichtungs-set-mit-vlies';
      }
      return 'https://www.heimwerker-direkt.de/easy-flachdachabdichtung-1k-198';
    },
    CTAParameter: function CTAParameter() {
      var keyword = this.$store.state.keyword;
      return '?pk_campaign=dynlp&pk_kwd=' + keyword + '&pk_source=dynlp&pk_medium=cta&utm_source=dynlp&utm_medium=cta&utm_campaign=dynlp&utm_term=' + keyword;
    }
  }),
  mounted: function mounted() {
    if (typeof this.$route.query.flachdachSet !== 'undefined') {
      this.flachdachSet = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb498f0c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calculator.vue
var Calculator_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"font-weight-bold",attrs:{"for":"length"}},[_vm._v("Länge")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getCalculator.length),expression:"getCalculator.length"}],staticClass:"w-100",attrs:{"type":"range","min":"1","max":"20"},domProps:{"value":(_vm.getCalculator.length)},on:{"input":function($event){_vm.$store.dispatch('saveCalculator', _vm.formData)},"__r":function($event){_vm.$set(_vm.getCalculator, "length", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getCalculator.length),expression:"getCalculator.length"}],staticClass:"form-control",attrs:{"id":"length","type":"number","min":"0"},domProps:{"value":(_vm.getCalculator.length)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.getCalculator, "length", $event.target.value)},function($event){_vm.$store.dispatch('saveCalculator', _vm.formData)}]}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon",attrs:{"id":"basic-addon2"}},[_vm._v("Meter")])])])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"font-weight-bold",attrs:{"for":"width"}},[_vm._v("Breite")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getCalculator.width),expression:"getCalculator.width"}],staticClass:"w-100",attrs:{"type":"range","min":"1","max":"20"},domProps:{"value":(_vm.getCalculator.width)},on:{"input":function($event){_vm.$store.dispatch('saveCalculator', _vm.formData)},"__r":function($event){_vm.$set(_vm.getCalculator, "width", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getCalculator.width),expression:"getCalculator.width"}],staticClass:"form-control",attrs:{"id":"length","type":"number","min":"0"},domProps:{"value":(_vm.getCalculator.width)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.getCalculator, "width", $event.target.value)},function($event){_vm.$store.dispatch('saveCalculator', _vm.formData)}]}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon",attrs:{"id":"basic-addon2"}},[_vm._v("Meter")])])])])])]),_vm._v(" "),(_vm.squareMeter > 0)?_c('div',[_c('div',{staticClass:"alert alert-success"},[_c('div',{staticClass:"mb-1"},[_vm._v("Bei einer Fläche von "),_c('strong',[_vm._v(_vm._s(_vm.squareMeter.toString().replace('.', ','))+" m²")]),_vm._v(" benötigen Sie "),_c('strong',[_vm._v("ca. "),_c('span',[_vm._v(_vm._s(_vm.consumption))]),_vm._v(" kg")])]),_vm._v(" "),_c('div',{staticClass:"mb-1"},[_vm._v("Verbrauch: "),(_vm.getCalculator.fleece)?_c('span',[_vm._v("2,0 kg/m²")]):_c('span',[_vm._v("1,4 kg/m²")])]),_vm._v(" "),_c('div',[_vm._v("Anzahl Anstriche: 2")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"m-0"},[_c('label',{staticClass:"custom-control custom-checkbox mb-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.fleece),expression:"formData.fleece"}],staticClass:"custom-control-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.formData.fleece)?_vm._i(_vm.formData.fleece,null)>-1:(_vm.formData.fleece)},on:{"change":[function($event){var $$a=_vm.formData.fleece,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.formData.fleece=$$a.concat([$$v]))}else{$$i>-1&&(_vm.formData.fleece=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.formData, "fleece", $$c)}},function($event){_vm.$store.dispatch('saveCalculator', _vm.formData)}]}}),_vm._v(" "),_c('span',{staticClass:"custom-control-indicator"}),_vm._v(" "),_vm._m(0,false,false)])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"custom-control custom-checkbox m-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.isB2B),expression:"user.isB2B"}],staticClass:"custom-control-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.user.isB2B)?_vm._i(_vm.user.isB2B,null)>-1:(_vm.user.isB2B)},on:{"change":[function($event){var $$a=_vm.user.isB2B,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.user.isB2B=$$a.concat([$$v]))}else{$$i>-1&&(_vm.user.isB2B=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.user, "isB2B", $$c)}},function($event){_vm.$store.dispatch('b2bUser', _vm.user.isB2B)}]}}),_vm._v(" "),_c('span',{staticClass:"custom-control-indicator"}),_vm._v(" "),_vm._m(1,false,false)])]),_vm._v(" "),_c('div',[_c('a',{staticClass:"btn btn-primary btn-block btn-lg",attrs:{"href":_vm.CTAURL+_vm.CTAParameter,"target":"_blank"}},[_vm._v(_vm._s(_vm.CTAText))])])])}
var Calculator_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"custom-control-description"},[_c('small',[_vm._v("Vliesverstärkung (höherer Verbrauch)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"custom-control-description"},[_c('small',[_vm._v("Ich bin professioneller Handwerker")])])}]
var Calculator_esExports = { render: Calculator_render, staticRenderFns: Calculator_staticRenderFns }
/* harmony default export */ var components_Calculator = (Calculator_esExports);
// CONCATENATED MODULE: ./src/components/Calculator.vue
function Calculator_injectStyle (ssrContext) {
  __webpack_require__("7xso")
}
var Calculator_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Calculator___vue_template_functional__ = false
/* styles */
var Calculator___vue_styles__ = Calculator_injectStyle
/* scopeId */
var Calculator___vue_scopeId__ = "data-v-bb498f0c"
/* moduleIdentifier (server only) */
var Calculator___vue_module_identifier__ = null
var Calculator_Component = Calculator_normalizeComponent(
  Calculator,
  components_Calculator,
  Calculator___vue_template_functional__,
  Calculator___vue_styles__,
  Calculator___vue_scopeId__,
  Calculator___vue_module_identifier__
)

/* harmony default export */ var src_components_Calculator = (Calculator_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-lazyload/vue-lazyload.js
var vue_lazyload = __webpack_require__("cTzj");
var vue_lazyload_default = /*#__PURE__*/__webpack_require__.n(vue_lazyload);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_lazyload_default.a);

vue_esm["a" /* default */].component('alfa-calculator', src_components_Calculator);

router.beforeEach(function (to, from, next) {
  window.scrollTo(0, 0);
  next();
});

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App: src_App },
  store: src_store
});

/***/ }),

/***/ "fwqL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.a3b2fb73f955509757ce.js